import { styled } from '@mui/material/styles';
import { FranchiseTabBar } from 'views/information-module/common/components/UI/FranchiseTabBar';

const FranchiseAsideBar = styled(FranchiseTabBar)(({ theme }) => ({
  '& .MuiTab-root': {
    color: theme.palette.grey[200],
    fontWeight: '500',
    alignItems: 'flex-start',
    borderLeft: `4px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(1, 2),
    minHeight: theme.typography.pxToRem(32),
    '&.Mui-selected': {
      color: theme.palette.primary.main,
      fontWeight: '500',
    },
  },
  '& .MuiTabs-indicator': {
    left: '0',
    width: '4px',
  },
}));
export { FranchiseAsideBar };
